import React, { useEffect, useRef, useState } from "react";

function TextEditor({ onChange, editorLoaded, name, value, placeholder = "Description In English" }) {
    const editorRef = useRef();
    const [editor, setEditor] = useState(null);

    useEffect(() => {

        const loadEditor = async () => {
            const { CKEditor, ClassicEditor } = await import("@ckeditor/ckeditor5-react");
            const editorBuild = await import("@ckeditor/ckeditor5-build-classic");

            editorRef.current = {
                CKEditor,
                ClassicEditor: editorBuild.default
            };

            setEditor(editorRef.current);
        };

        loadEditor();
    }, []);

    return (
        <div>
            {editorLoaded && editor ? (
                <editor.CKEditor
                    type=""
                    name={name}
                    className="custom-ckeditor"
                    editor={editor.ClassicEditor}
                    config={{
                        ckfinder: {
                            uploadUrl: "" // Enter your upload URL
                        },
                        placeholder: placeholder,
                        toolbar: ['heading', '|', 'bold', 'italic', 'blockQuote', 'link', 'numberedList', 'bulletedList', 'insertTable',
                            'tableColumn', 'tableRow', 'mergeTableCells', '|', 'undo', 'redo']
                    }}
                    data={value}
                    onChange={(event, editor) => {
                        const data = editor.getData();
                        onChange(data);
                    }}
                />
            ) : null}
        </div>
    );
}

export default TextEditor;
